import { Outlet, Navigate, useLocation } from "react-router-dom"
import svAuth from "./svAuth"

const SiteVisitAuth = () => {
    const location = useLocation()

    return svAuth.token() ? (
        <Outlet />
    ) : (
        <Navigate to="/site-visit/auth" replace state={{ from: location }} />
    )
}

export default SiteVisitAuth
